<template>
  <vue-cookie-accept-decline :debug="false" :disableDecline="false" :showPostponeButton="false"
    @clicked-accept="cookieClickedAccept" @clicked-decline="cookieClickedDecline"
    @clicked-postpone="cookieClickedPostpone" @removed-cookie="cookieRemovedCookie" @status="cookieStatus"
    elementId="cookies_modal" position="bottom-left" ref="myPanel1" transitionName="slideFromBottom" type="floating">
    <template #postponeContent>&times;</template>

    <template #message>
      <p class="cookies_modal_title mb-0">We use cookies </p>
      <p class="cookies_modal_subtitle mb-0">We use Google Analytics to analyze website traffic </p>
      <v-row class="ma-0">
        <v-col cols="6" class="pa-0">
          <v-checkbox v-model="selected_cookies" disabled color="#227535" base-color="#fff" class="text-white"
            label="Necessary" value="1" hide-details density="compact"></v-checkbox>
        </v-col>
        <v-col cols="6" class="pa-0">
          <v-checkbox v-model="selected_cookies" color="#227535" base-color="#fff" class="text-white"
            label="Preferences" value="2" hide-details density="compact"></v-checkbox>
        </v-col>
        <v-col cols="6" class="pa-0">
          <v-checkbox v-model="selected_cookies" color="#227535" base-color="#fff" class="text-white" label="Statistics"
            value="3" hide-details density="compact"></v-checkbox>
        </v-col>
        <v-col cols="6" class="pa-0">
          <v-checkbox v-model="selected_cookies" color="#227535" base-color="#fff" class="text-white" label="Marketing"
            value="4" hide-details density="compact"></v-checkbox>
        </v-col>
      </v-row>
    </template>

    <template #acceptContent>ACCEPT</template>

    <template #declineContent>DECLINE </template>
  </vue-cookie-accept-decline>
</template>
<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      selected_cookies: ["1", "2", "3", "4"],
    };
  },
  methods: {
    cookieStatus(status) {
      this.status = status;

      if (status == "accept") {
        this.selected_cookies = localStorage.getItem("vue-cookie-accept-decline-cookies_modal_select") ?? [];
        const consentSettings = {};
        if (this.selected_cookies.includes("2")) {
          consentSettings['ad_user_data'] = 'granted';
          consentSettings['ad_personalization'] = 'granted';
        }
        if (this.selected_cookies.includes("3")) {
          consentSettings['analytics_storage'] = 'granted';
        }
        if (this.selected_cookies.includes("4")) {
          consentSettings['ad_user_data'] = 'granted';
          consentSettings['ad_storage'] = 'granted';
        }
        if (!this.selected_cookies.includes("2") && !this.selected_cookies.includes("4")) {
          consentSettings['ads_data_redaction'] = 'true';
        }
        setTimeout(() => {
          window.gtag('consent', 'update', consentSettings);
        }, 200);

      } else {
        const consentSettings = {
          'ad_storage': 'denied',
          'analytics_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied',
          'ads_data_redaction': 'true'
        };
        window.gtag('consent', 'update', consentSettings);
      }
    },
    cookieClickedAccept() {
      const consentSettings = {};

      if (this.selected_cookies.includes("2")) {
        consentSettings['ad_user_data'] = 'granted';
        consentSettings['ad_personalization'] = 'granted';
      }
      if (this.selected_cookies.includes("3")) {
        consentSettings['analytics_storage'] = 'granted';
      }
      if (this.selected_cookies.includes("4")) {
        consentSettings['ad_user_data'] = 'granted';
        consentSettings['ad_storage'] = 'granted';
      }
      if (!this.selected_cookies.includes("2") && !this.selected_cookies.includes("4")) {
        consentSettings['ads_data_redaction'] = true;
      }
      if (Object.keys(consentSettings).length > 0) {
        window.gtag('consent', 'update', consentSettings);
      }
      localStorage.setItem("vue-cookie-accept-decline-cookies_modal_select", this.selected_cookies)
      this.status = this.selected_cookies;
    },
    cookieClickedDecline() {
      this.status = [];
    },
    cookieClickedPostpone() {
      console.log('here in postpone');
      this.status = 'postpone';
    },
    cookieRemovedCookie() {
      this.status = null;
      this.$refs.myPanel1.init();
    },
    removeCookie() {
      console.log('Cookie removed');
      this.$refs.myPanel1.removeCookie();
    },
  },
}
</script>

<style scoped>
#cookies_modal {
  background: #2a3228;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  box-shadow: unset;
}

.cookies_modal_title {
  color: #F7F5F1;
  font-size: 1.2rem;
  font-weight: 300;
  letter-spacing: -0.02rem;
}

.cookies_modal_subtitle {
  color: #F7F5F1;
  font-size: 0.8rem;
  font-weight: 300;
}

#cookies_modal.v-label {
  font-weight: 300;
  font-size: 0.9rem;
}
</style>
<style>
@import url("vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css");

#cookies_modal .cookie__floating__content {
  margin-bottom: 0px;
  max-height: unset;
}

#cookies_modal .cookie__floating__buttons__button--decline {
  background: transparent !important;
  color: #5f5f5f;
  border: unset;
  font-weight: 400;
  transition: .3s;
}

#cookies_modal .cookie__floating__buttons__button--decline:hover {
  color: #f44336;
  background: rgba(255, 255, 255, 0.1) !important;
}

#cookies_modal .cookie__floating__buttons__button--accept {
  background: transparent !important;
  color: #227535;
  border: unset;
  font-weight: 400;
  transition: .3s;
}

#cookies_modal .cookie__floating__buttons__button--accept:hover {
  color: #4caf50;
  background: rgba(255, 255, 255, 0.1) !important;
}
</style>